export const MAP_COLOR_THEME_STYLE = {
  DEFAULT_SWATCH_COLOR: "#FFFFFF",
} as const;
